import React from 'react';
import { useLocation } from 'react-router';
import cn from 'classnames';

import { SmartLink } from 'components';
import { Action, Category } from 'services/analytics';
import { FeaturedConfig } from '../../../types';
import FeaturedTournamentsLogo from '../FeaturedTournamentsLogo';

import './featuredTournamentsRow.scss';

interface Props {
    config: FeaturedConfig;
}

const FeaturedTournamentsRow: React.FC<Props> = ({ config }) => {
    const { pathname } = useLocation();

    const { linkToTournament, name, logo } = config;

    if (!name || !linkToTournament) return null;

    const isActive = pathname === linkToTournament;

    return (
        <SmartLink styleName="container" to={linkToTournament}>
            <FeaturedTournamentsLogo logo={logo} />

            <div
                styleName="info"
                data-action={Action.SelectTournament}
                data-category={Category.FiltersFeatured}
            >
                <div
                    styleName={cn('name', {
                        'is-active': isActive,
                    })}
                >
                    {name}
                </div>
            </div>
        </SmartLink>
    );
};

export default React.memo(FeaturedTournamentsRow);
